module.exports = __webpack_public_path__ + "img/Barrel-Laptop.dcab324a.png";